import { useEffect, useRef, useState } from 'react'
import { catchError, concatMap, from, interval, of, startWith } from 'rxjs'

export const useInterval = (callback, delay, autoStart = true) => {
  const [isRunning, setIsRunning] = useState(autoStart)
  const callbackRef = useRef(callback)
  const subRef = useRef()

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const stop = () => {
    setIsRunning(false)
    subRef.current?.unsubscribe()
  }

  const start = () => {
    setIsRunning(true)
  }

  const toggle = () => {
    setIsRunning((prev) => !prev)
  }

  useEffect(() => {
    if (isRunning && delay !== null) {
      subRef.current = interval(delay)
        .pipe(
          startWith(0),
          concatMap(() =>
            from(callbackRef.current()).pipe(
              catchError((err) => {
                console.error('useInterval callback error:', err)
                return of(null)
              })
            )
          )
        )
        .subscribe()
    }

    return () => {
      subRef.current?.unsubscribe()
    }
  }, [isRunning, delay])

  return {
    stop,
    start,
    toggle,
    isRunning,
  }
}
